module.exports = __webpack_public_path__ + "img/divider.4ced388c.svg";